/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMProductViewPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import { getAvailableProductSizes } from 'integration/utils/getAvailableProductSizes';
import {mergeRibbonsForProduct} from '@/utils/mergeRibbonsForProduct';

// eslint-disable-next-line complexity
export const getGTMProductViewEventData = async (payload: GTMProductViewPayload) => {
	const { product, listerFlag, storeName, availability, source } = payload;
	const { partNumber, name, productPrice, manufacturer, inventories, attributes } = product;
	const currency = productPrice?.currency ?? '';
	const marketplaceStore = storeName;
	const affiliation = 'Dportenis'; // This should be the Seller Organization name
	const value = productPrice?.offer;
	const list = productPrice?.list;

	const genre = findProductAttribute(attributes, 'Genero')?.value;
	const family = findProductAttribute(attributes, 'Familia')?.value;
	const use = findProductAttribute(attributes, 'Uso')?.value;
	const color = findProductAttribute(attributes, 'Color1')?.value;
	const ribbons = mergeRibbonsForProduct(product.ribbons).flatMap((ribbon) => ribbon.value);
	const sizes = getAvailableProductSizes(product, availability);
	const availableQuantity = availability?.length ? Number(availability[0].availableQuantity) : 0;
	const lowStock = (availableQuantity > 0 && availableQuantity < 15) ? 'Si' : 'No';
	const priceType = (value ?? 0) > 0 && value !== (list ?? 0) ? 'Oferta' : 'Full price';


	const products = [
		{
			id: partNumber,
			name,
			price: productPrice?.offer,
			category: genre, // not used
			category1: family,
			category2: use,
			category3: '',
			category4: '',
			category5: '',
			list: listerFlag ? 'Category' : 'Search Results',
			currency: productPrice.currency,
			brand: manufacturer,
			affiliation,
			productPrice,
			inventories,
			// Do we need these parameters?
			position: undefined,
			color,
			ribbons,
			sizes,
			lowStock,
			priceType,
		},
	];

	return { products, currencyCode: currency, marketplaceStore, value, source };
};
